import { Box, Typography } from "@mui/material";
import ImagePreviewer from "../../common/Behelit/ImagePreview";
import lugar from "../../assets/img/lugarMaps.png";
import compartir from "../../assets/img/compartirLugar.png";

export const InfoMapa: React.FC<{}> = () => {
  return (
    <Box sx={{ textAlign: 'center', marginBottom: 2 }}>
      <Typography variant="body1" gutterBottom>
        Para el enlace de mapa, solo necesitas ingresar al Google Maps y buscar el lugar del evento.
      </Typography>
      <ImagePreviewer image={lugar} />
      <Typography variant="body1" gutterBottom>
        A continuación solo necesitas dar en compartir y copiar el enlace del lugar, el cual insertará en el campo del formulario.
      </Typography>
      <ImagePreviewer image={compartir} />
    </Box>
  );
}